function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 1a8 8 0 017.996 7.75L17 9a8 8 0 01-7.75 7.996L9 17A8 8 0 119 1zm0 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM9.351 6a.318.318 0 01.193.071l3.313 2.622c.15.117.188.35.084.52a.354.354 0 01-.084.094L9.544 11.93c-.154.123-.368.082-.478-.091a.419.419 0 01-.063-.216V9.747H5.666c-.368 0-.666-.336-.666-.75 0-.415.298-.75.666-.75h3.337v-1.87c.003-.212.16-.382.348-.378z",
  fill: "#148CFC"
});

var SvgGo = function SvgGo(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none"
  }, props), _ref);
};

export default SvgGo;